import { IPrompt, scopeType } from 'wisestep-api';

export const defaultTitleHeading = {
  'Recruiter Questions': 'No. Of Questions to Generate',
  'Candidate Summary': 'No. Of Words to Generate',
};

export const generateDefaultPayload = (scope: scopeType, workspaceId): IPrompt => {
  return {
    promptTitle: 'Default Prompt',
    prompt: '',
    numberOfQuestion: scope == scopeType.RECRUITER_QUESTION ? 5 : 0,
    jdCount: scope == scopeType.RECRUITER_QUESTION ? 250 : 0,
    active: true,
    default: true,
    workspaceId: workspaceId,
    scope: scope,
    numberOfWords: scope == scopeType.CANDIDATE_SUMMARY ? 250 : 0,
  };
};

export const generateNewPromptItem = (promptTitle: string, prompt: string, prevData: IPrompt) => {
  return {
    promptTitle: promptTitle,
    prompt: prompt,
    numberOfQuestion: prevData.numberOfQuestion,
    jdCount: prevData.jdCount,
    active: false,
    default: false,
    workspaceId: prevData.workspaceId,
    scope: prevData.scope,
    numberOfWords: prevData.numberOfWords,
  };
};
